import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },

  passwordIcon: {
    cursor: 'pointer',
  },

  content: {
    display: 'flex',
    flex: 1,
    gap: spacing(4),
  },

  left: {
    width: '300px',
  },

  line: {
    display: 'flex',
    gap: spacing(2),
    marginBottom: '1.5rem',
  },

  lineAddress: {
    display: 'flex',
    gap: spacing(2),
  },

  section: {
    marginBottom: '0.5rem',
  },

  right: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: spacing(4)
  },
}));

export default useStyles;
